import { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { Upload, FileSpreadsheet } from 'lucide-react'
import clsx from 'clsx'

const ACCEPTED = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel': ['.xls'],
  'text/csv': ['.csv'],
}

export default function DropZone({ onFiles, disabled }: {
  onFiles: (files: File[]) => void; disabled?: boolean
}) {
  const onDrop = useCallback((accepted: File[]) => { if (accepted.length) onFiles(accepted) }, [onFiles])
  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    onDrop, accept: ACCEPTED, disabled, multiple: true, maxSize: 50 * 1024 * 1024,
  })

  return (
    <div
      {...getRootProps()}
      className={clsx('upload-zone', isDragActive && !isDragReject && 'drag-active')}
      style={isDragReject ? { borderColor: '#ef4444', background: '#fef2f2' } : {}}
    >
      <input {...getInputProps()} />

      <div style={{
        width: 60, height: 60, borderRadius: 14,
        background: isDragActive ? '#e0f9ff' : 'linear-gradient(135deg,#0096c7,#0077b6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        margin: '0 auto 20px',
        transition: 'all .2s',
        boxShadow: '0 4px 14px rgba(0,150,199,.25)',
      }}>
        {isDragActive
          ? <FileSpreadsheet size={26} color="#0096c7" />
          : <Upload size={26} color="#fff" />
        }
      </div>

      {isDragReject ? (
        <>
          <p style={{ fontSize: 16, fontWeight: 600, color: '#b91c1c', marginBottom: 6 }}>Unsupported file type</p>
          <p style={{ fontSize: 13, color: 'var(--text-2)' }}>Please drop .xlsx, .xls, or .csv files only</p>
        </>
      ) : isDragActive ? (
        <>
          <p style={{ fontSize: 16, fontWeight: 600, color: 'var(--cyan-dark)', marginBottom: 6 }}>Release to upload</p>
          <p style={{ fontSize: 13, color: 'var(--text-2)' }}>Files will start processing immediately</p>
        </>
      ) : (
        <>
          <p style={{ fontSize: 17, fontWeight: 600, color: 'var(--text-1)', marginBottom: 6 }}>
            Drop expense files here
          </p>
          <p style={{ fontSize: 13, color: 'var(--text-2)', marginBottom: 22 }}>
            Multiple files process simultaneously — no waiting required
          </p>
          <button type="button" className="btn btn-primary" style={{ margin: '0 auto' }}>
            <Upload size={14} /> Browse Files
          </button>
          <p style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 14 }}>
            .xlsx · .xls · .csv · Max 50 MB per file
          </p>
        </>
      )}
    </div>
  )
}
